import { RPLUS_EPUB_TITLE } from '../../../common/constants';

const STYLE_ID = 'evergreen-title-content-override';
const WORD8_FONT_SIZE = '14px';
const APPLY_DELAYS_MS = [0, 300, 1000, 2000];

let applyRetryTimers = [];

const OVERRIDES = {
  57101021609: `#word8 .s8 { font-size: ${WORD8_FONT_SIZE} !important; }`
};

const getOverrideCss = ({ bookId, globalBookId, titleType }) => {
  if (titleType !== RPLUS_EPUB_TITLE) {
    return undefined;
  }
  const bookKey = String(bookId || '');
  const globalKey = String(globalBookId || '');
  return OVERRIDES[bookKey] || OVERRIDES[globalKey];
};

const applyToDocument = (doc, css) => {
  if (!doc) {
    return;
  }

  let styleEl = doc.getElementById(STYLE_ID);
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.id = STYLE_ID;
    (doc.head || doc.documentElement).appendChild(styleEl);
  }
  styleEl.textContent = css;
  doc.querySelector('#word8 .s8')?.style.setProperty('font-size', WORD8_FONT_SIZE, 'important');
};

const removeStyleFromDocument = (doc) => {
  doc?.getElementById(STYLE_ID)?.remove();
};

export const clearTitleContentStyleOverrideSchedule = () => {
  applyRetryTimers.forEach(clearTimeout);
  applyRetryTimers = [];
};

export const removeTitleContentStyleOverride = () => {
  clearTitleContentStyleOverrideSchedule();
  removeStyleFromDocument(document);
  document.querySelectorAll('iframe').forEach((iframe) => {
    try {
      removeStyleFromDocument(iframe.contentDocument);
    } catch (error) {
      // Cross-origin iframe; ignore.
    }
  });
};

export const applyTitleContentStyleOverride = ({ bookId, globalBookId, titleType }) => {
  const css = getOverrideCss({ bookId, globalBookId, titleType });
  if (!css) {
    removeTitleContentStyleOverride();
    return;
  }

  applyToDocument(document, css);
  document.querySelectorAll('iframe').forEach((iframe) => {
    try {
      applyToDocument(iframe.contentDocument, css);
    } catch (error) {
      // Cross-origin iframe; ignore.
    }
  });
};

/** Re-apply after Vega/iframes mount (R+ EPUB title-specific CSS). */
export const scheduleTitleContentStyleOverride = (context) => {
  clearTitleContentStyleOverrideSchedule();
  applyRetryTimers = APPLY_DELAYS_MS.map((delay) => setTimeout(() => applyTitleContentStyleOverride(context), delay));
};
